import { render, staticRenderFns } from "./UMLException.vue?vue&type=template&id=5ee04062&scoped=true&"
import script from "./UMLException.vue?vue&type=script&lang=js&"
export * from "./UMLException.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee04062",
  null
  
)

export default component.exports